export enum ActionTypes {
  UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS",
  FETCH_CSRF_INFORMATION = "FETCH_CSRF_INFORMATION",
  UPDATE_BANNER_STATUS = "UPDATE_BANNER_STATUS",
  UPDATE_DIALOG_STATUS = "UPDATE_DIALOG_STATUS",
  UPDATE_NOTIFICATION_STATUS = "UPDATE_NOTIFICATION_STATUS",
  UPDATE_ALERT_STATUS = "UPDATE_ALERT_STATUS"
}
